












import { Component, Vue } from 'vue-property-decorator'
import { EventBus } from '../../utils/event-bus'

@Component({
  name: 'fire-fly',
  components: {
  }
})
export default class FireFly extends Vue {
  flyStyle = ''
  iconStyle1 = '';
  iconStyle2 = '';
  iconStyle3 = '';
  iconStyle4 = '';
  show = false
  scrollTop = 0
  mounted() {
    EventBus.$on('fireFly', (data: any) => {
      this.show = true
      this.$nextTick(() => {
        this.setLayout(data)
      })
    })
    window.addEventListener('scroll', this.windowScroll)
  }
  windowScroll() {
    this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
  }
  stopPenetrate() {
    return false
  }
  setLayout(data: any) {
    const $icon: any = this.$refs.flyIcon
    const { width, height } = $icon.getBoundingClientRect()
    const { gx, gy, lx, ly } = data
    const h = Math.abs(ly - gy)
    const w = Math.abs(gx - lx)
    let left = gx
    let top = gy
    let position = 'right: 0; bottom: 0;'
    let anitName = 'flyLeft'
    const t = h / 100 * 0.35
    if (gx > lx) {
      left = lx
      top = gy
      position = 'left: 0; bottom: 0;'
      anitName = 'flyRight'
    }

    this.setKeyframes({ w, h, width, height, anitName })
    top += this.scrollTop
    this.flyStyle = `top: ${top}px; left: ${left}px; width:${w + width}px; height:${h + height}px;`

    setTimeout(() => {
      this.iconStyle1 = `${position} animation: ${anitName} ${t}s 0.2s 1 linear forwards;`
      this.iconStyle2 = `${position} animation: ${anitName} ${t}s 0.4s 1 linear forwards;`
      this.iconStyle3 = `${position} animation: ${anitName} ${t}s 0.6s 1 linear forwards;`
      this.iconStyle4 = `${position} animation: ${anitName} ${t}s 0.8s 1 linear forwards;`

      if (this.scrollTop > Math.abs(top)) {
        this.changeScroll(t, Math.abs(top))
        setTimeout(() => {
          if (this.show) {
            this.animationend()
          }
        }, (t + 1) * 1000)
      }
    }, 100)
  }
  changeScroll(time: number, target: number) {
    let top = this.scrollTop
    const totalTime = (time * 1000) * 0.7
    const speed = 25
    const count = totalTime / speed
    const move = (this.scrollTop - target) / count
    const st = setInterval(() => {
      if (top <= target) {
        clearInterval(st)
      } else {
        top -= move
        if (document.documentElement.scrollTop) {
          document.documentElement.scrollTop = top
        } else {
          window.scrollTo(0, top)
        }
      }
    }, speed)
  }
  setKeyframes(tagetOb: any) {
    const { w, h, anitName } = tagetOb
    const flyLeft = `@keyframes flyLeft{
      0%{
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }
      99% {
        opacity: 1;
        transform: translate3d(-${w}px, -${h}px, 0);
      }
      100% {
        opacity: 0;
      }
    }`
    const flyRight = `@keyframes flyRight{
      0%{
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }
      99% {
        opacity: 1;
        transform: translate3d(${w}px, -${h}px, 0);
      }
      100% {
        opacity: 0;
      }
    }`
    if (anitName === 'flyLeft') {
      document.styleSheets[0].insertRule(flyLeft)
    } else {
      document.styleSheets[0].insertRule(flyRight)
    }
  }
  async animationend() {
    this.show = false
    this.flyStyle = ''
    this.iconStyle1 = ''
    this.iconStyle2 = ''
    this.iconStyle3 = ''
    this.iconStyle4 = ''
    await EventBus.$emit('fireFlyEnd')
    document.styleSheets[0].deleteRule(0)
    this.$store.dispatch('freeOrder/bootUser', { force: true })
  }
}
